/**
 * 계정 섹션 버전 선택기
 * props 또는 환경변수로 버전을 동적으로 전환 가능
 */ import React from 'react';
// 두 가지 버전 import
import AccountSectionOriginal from './AccountSection';
import AccountSectionHeroUI from './AccountSection.heroui';
export const AccountSectionSelector = ({ version, ...props })=>{
    const finalVersion = version ?? 'heroui';
    switch(finalVersion){
        case 'original':
            return /*#__PURE__*/ React.createElement(AccountSectionOriginal, props);
        case 'heroui':
        default:
            return /*#__PURE__*/ React.createElement(AccountSectionHeroUI, props);
    }
};
export default AccountSectionSelector;
